import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar } = FiIcons;

const reviews = [
  { author: "J.K.", text: "Materials are insane. Worth every penny." },
  { author: "M.T.", text: "Missed the last drop. Finally copped the Concrete. Flawless." },
  { author: "S.R.", text: "Aesthetic is aggressive, fit is perfectly dialed in." }
];

const Reviews = () => {
  return (
    <section className="py-20 bg-acid text-black overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-black uppercase tracking-tighter mb-12 border-b border-black/20 pb-4">Transmission Logs</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((rev, idx) => (
            <div key={idx} className="border-l-4 border-black pl-6">
              <div className="flex mb-3">
                {[...Array(5)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="w-4 h-4 fill-black" />
                ))}
              </div>
              <p className="text-lg font-bold uppercase tracking-wide leading-snug mb-4">"{rev.text}"</p>
              <span className="font-mono text-sm opacity-60">USR_{rev.author}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;